import { FormControl, ListItemText, MenuItem } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Select from "@mui/material/Select";
import { GENERIC_MEMBER_STATUS_OPTIONS } from "constants/index";
import { useState } from "react";

import { ReactComponent as ArrowDownIcon } from "../../../assets/images/square-buttons/chevron-down-green.svg";
import { ReactComponent as CheckOff } from "../../../assets/images/toggle-checkboxes/square/off-normal.svg";
import { ReactComponent as CheckOn } from "../../../assets/images/toggle-checkboxes/square/on-normal.svg";

const CustomSelect = ({
  options = GENERIC_MEMBER_STATUS_OPTIONS,
  defaultOptions = [GENERIC_MEMBER_STATUS_OPTIONS[0].value],
  handler,
  multiple = true,
}) => {
  const [selectedOptions, setSelectedOptions] = useState(defaultOptions);

  const updateSelectedOptions = (value, isSelectedAllClicked) => {
    if (!multiple) {
      setSelectedOptions([value]);
      handler([value]);
    } else {
      const selectAllOptions = options.find((e) => e.isSelectAll);
      let updatedSelectedOptions = [];

      if (isSelectedAllClicked) {
        updatedSelectedOptions = [selectAllOptions.value];
      } else {
        if (selectedOptions.includes(value)) {
          updatedSelectedOptions = selectedOptions.filter((e) => e !== value);
        } else {
          updatedSelectedOptions = [
            ...selectedOptions.filter((e) => !selectAllOptions || e !== selectAllOptions.value),
            value,
          ];
        }
      }
      setSelectedOptions(updatedSelectedOptions);
      handler(updatedSelectedOptions);
    }
  };

  function CustomSvgIcon(props) {
    return <ArrowDownIcon {...props} />;
  }

  return (
    <FormControl sx={{ borderRadius: 23, width: 166 }}>
      <Select
        variant="standard"
        id="demo-multiple-checkbox"
        multiple={multiple}
        value={selectedOptions}
        sx={{
          background: "#fff",
          border: `1px solid #d6eeec`,
          borderRadius: 23,
          color: "#33a9a0",
        }}
        disableUnderline={true}
        renderValue={(selected) =>
          (multiple && selected.map((x) => options.find((e) => e.value === x)?.label).join(", ")) ||
          options.find((e) => e.value === selected[0])?.label
        }
        IconComponent={CustomSvgIcon}
        SelectDisplayProps={{
          style: {
            backgroundColor: "#ffffff",
            borderRadius: 23,
            color: "#313a3d",
            fontFamily: "Mulish",
            fontSize: 14,
            fontStyle: "normal",
            fontWeight: "bold",
            paddingBottom: 11.5,
            paddingLeft: 14,
            paddingTop: 11.5,
            textAlign: "left",
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              "& .Mui-selected": {
                backgroundColor: "transparent !important",
              },
              "& .MuiButtonBase-root": {
                "& :hover": {
                  backgroundColor: "transparent",
                },
                fontFamily: "Mulish",
                fontSize: 14,
                fontStyle: "normal",
                fontWeight: "bold",
                lineHeight: 18,
              },
              "& .MuiMenuItem-root span": {
                padding: 0,
              },
              "& .MuiMenuItem-root span>svg": {
                marginRight: 1,
              },
              borderRadius: 5.75,
            },
          },
        }}
      >
        {options.map((option, i) => (
          <MenuItem
            key={i}
            value={option.value}
            onClick={(_e) => {
              updateSelectedOptions(option.value, option.isSelectAll);
            }}
          >
            <Checkbox
              checked={selectedOptions.indexOf(option.value) > -1}
              checkedIcon={<CheckOn />}
              icon={<CheckOff />}
            />
            <ListItemText
              primary={option.label}
              sx={{
                borderRadius: 23,
                color: "#313a3d",
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;
